import { useMediaQuery, useTheme } from "@mui/material";

const useIsWidthUp = (breakpoint) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(breakpoint));
};

export default useIsWidthUp;
